import gql from 'graphql-tag';

export const ARCHIVE_LOCATION_ENVIRONMENT_MUTATION = gql`
  mutation ArchiveLocationEnvironment($input: ArchiveLocationEnvironmentInput!) {
    archiveLocationEnvironment (input: $input) {
      id
    }
  }
`;


export const UNARCHIVE_LOCATION_ENVIRONMENT_MUTATION = gql`
  mutation UnarchiveLocationEnvironment($input: UnarchiveLocationEnvironmentInput!) {
    unarchiveLocationEnvironment (input: $input) {
      id
    }
  }
`;
